import React from 'react'
import Skeleton from '../Skeleton/Skeleton'
import styles from './ProductSkeleton.module.css'

export default function ProductSkeleton() {
  return (
    <div className={styles.productSkeleton}>
      {/* Product Image */}
      <div className={styles.imageContainer}>
        <Skeleton width="100%" height="100%" variant="rounded" className={styles.imageSkeleton} />
      </div>

      {/* Product Info */}
      <div className={styles.content}>
        {/* Title */}
        <Skeleton width="80%" height="1.04vw" variant="text" className={styles.titleSkeleton} />

        {/* Description */}
        <Skeleton
          width="60%"
          height="0.83vw"
          variant="text"
          className={styles.descriptionSkeleton}
        />

        {/* Price */}
        <div className={styles.priceContainer}>
          <Skeleton
            width="4.17vw"
            height="1.25vw"
            variant="text"
            className={styles.priceSkeleton}
          />
          <Skeleton
            width="2.08vw"
            height="0.83vw"
            variant="text"
            className={styles.oldPriceSkeleton}
          />
        </div>

        {/* Tags */}
        <div className={styles.tagsContainer}>
          <Skeleton
            width="2.5vw"
            height="0.83vw"
            variant="rounded"
            className={styles.tagSkeleton}
          />
          <Skeleton
            width="3.33vw"
            height="0.83vw"
            variant="rounded"
            className={styles.tagSkeleton}
          />
        </div>
      </div>
    </div>
  )
}
